import CustomButton from 'components/buttons/CustomButton/CustomButton'
import CustomDialog from 'components/dialogs/CustomDialog'
import { useAuth } from 'context/AuthContext';
import { useRegistryContext } from 'context/RegistryContext';
import { ERegistryStatus } from 'enum/ERegistryStatus';
import { useRevokeRegistryUser } from 'hooks/useRegistryUsers';
import { useMemo } from 'react';
import { snackbarService } from 'services/snackbarService';

interface Props {
  open: boolean;
  setOpen: (value: boolean) => void;
  endUser: any;
  refetch?: () => void;
  after?: () => void;
}
export default function RevokeRegistryUserDialog({
  open,
  setOpen,
  endUser,
  refetch,
  after,
}: Props) {
  const { user } = useAuth();
  const { registry } = useRegistryContext();

  const { mutate: revokeMutation, isLoading } = useRevokeRegistryUser(
    (res: any) => {
      const { data, status_code: statusCode } = res;
      if (statusCode == 200) {
        refetch?.();
        setOpen(false);
        after?.();
        snackbarService.showSnackbar('Revoked successfully', 'success');
      } else {
        snackbarService.showSnackbar(data, 'error');
      }
    },
    (error: any) => {
      setOpen(false);
    }
  );

  const handleConfirmRevoke = () => {
    revokeMutation({
      registryId: registry.id,
      userId: endUser.user.id,
    })
  };


  const isPendingStatus = useMemo(() => {
    return endUser.status == ERegistryStatus.PENDING;
  }, [endUser]);


  return (
    <CustomDialog
      open={open}
      title={isPendingStatus ? `Cancel Invitation` : `Revoke Access`}
      message={isPendingStatus ? `Are you sure you want to cancel this invitation?` : `Are you sure you want to revoke ${endUser.user.name}'s access to this registry?`}
      alignText='left'
      buttons={[
        <CustomButton
          key='cancel'
          variant='outlined'
          text='Cancel'
          onClick={() => setOpen(false)}
          disabled={isLoading}
          height={35}
        />,
        <CustomButton
          key='delete'
          variant='filled'
          color='error'
          text={isPendingStatus ? 'Cancel invitation' : 'Revoke'}
          onClick={handleConfirmRevoke}
          loading={isLoading}
          height={35}
        />,
      ]}
    />
  )
}
